import { Injectable } from '@angular/core';
import {
  IDashboardProductosMasVendidosPaginadoRes,
  IDashboardRes,
} from '@core/interfaces/components/dashboard.component.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class DasbboardApiService extends BaseHttpService {
  getDashboardData(fecha_inicio: Date, fecha_fin: Date) {
    return this.withLoader(
      this.httpClient.post<IDashboardRes>(
        `${environment.apiUrl}${environment.apiPreFix}/dashboard`,
        {
          fecha_inicio,
          fecha_fin,
        },
      ),
    );
  }

  getProductosMasVendidosPaginado(fecha_inicio: Date, fecha_fin: Date, offset: number, limit = 10) {
    return this.withLoader(
      this.httpClient.post<IDashboardProductosMasVendidosPaginadoRes>(
        `${environment.apiUrl}${environment.apiPreFix}/dashboard/productos-mas-vendidos`,
        {
          fecha_inicio,
          fecha_fin,
          offset,
          limit,
        },
      ),
    );
  }
}
